import React, { useEffect, useState } from "react";
import _ from "lodash";

import { Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { DBCitySearchReturnDetails } from "../Common/Ui/DBCitySearchReturnDetails";
import { toast } from "react-toastify";
import { SendQueryFormComponent } from "../Common/SendQueryFormComponent";
import Joi from "joi";
import { ErrorText } from "../errors/ErrorText";
import { joiResolver } from "@hookform/resolvers/joi";
import DatePicker from "react-date-picker";
import moment from "moment";
import { CustomStaticSelect } from "../Common/Ui/CustomStaticSelect";

type FormValues = {
  fromCityDetails: string;
  toCityDetails: string;
  travelDate?: Date;
  class: string;
};

const trainSchema = Joi.object({
  fromCityDetails: Joi.string().required().label("From City"),
  toCityDetails: Joi.string().required().label("To City"),
  travelDate: Joi.date().required().label("Travel Date"),
  class: Joi.string().required().label("Class"),
});

const classArr = [
  {
    value: "Sleeper",
  },
  {
    value: "First AC",
  },
  {
    value: "Second AC",
  },
  {
    value: "Third Ac",
  },
];

const TrainQueryForm: React.FC = (props) => {
  const [loadingState, setLoadingState] = useState(false);

  const [showFormSubmissionPopup, setShowFormSubmissionPopup] = useState(false);

  const onSubmit = (data: FormValues) => {
    setShowFormSubmissionPopup(true);
  };

  const { handleSubmit, register, watch, formState, setValue, getValues } =
    useForm<FormValues>({
      resolver: joiResolver(trainSchema),
      defaultValues: {
        fromCityDetails: undefined,
        toCityDetails: undefined,
        travelDate: undefined,
      },
    });

  const formData = watch();

  const errors = formState.errors;

  return (
    <div className="tab-pane active p-4">
      <div className="row">
        <h3 className="after-heading">Train Enquiry</h3>
      </div>
      <div className="row">
        <form>
          <div className="row mb-4">
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="form-group with-icon">
                <label className=" mb-0">From City</label>
                <DBCitySearchReturnDetails
                  value={
                    getValues("fromCityDetails") &&
                    getValues("fromCityDetails").length > 0
                      ? getValues("fromCityDetails")
                      : undefined
                  }
                  onChange={(city) => {
                    if (city) {
                      setValue("fromCityDetails", city.label);
                    } else {
                      setValue("fromCityDetails", "");
                    }
                  }}
                  error={errors.fromCityDetails?.message}
                />
                <ErrorText error={errors.fromCityDetails?.message} />
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="form-group with-icon">
                <label className=" mb-0">To City</label>
                <DBCitySearchReturnDetails
                  value={
                    getValues("toCityDetails") &&
                    getValues("toCityDetails").length > 0
                      ? getValues("toCityDetails")
                      : undefined
                  }
                  onChange={(city) => {
                    if (city) {
                      setValue("toCityDetails", city.label);
                    } else {
                      setValue("toCityDetails", "");
                    }
                  }}
                  error={errors.toCityDetails?.message}
                />
                <ErrorText error={errors.toCityDetails?.message} />
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="form-group with-icon">
                <label className=" mb-0">Travel Date</label>

                <DatePicker
                  className="bg-light w-100 form-control"
                  value={getValues("travelDate")}
                  clearIcon={null}
                  onChange={(date) => {
                    setValue("travelDate", date);
                  }}
                  format="dd-MM-y"
                  dayPlaceholder="DD"
                  monthPlaceholder="MM"
                  yearPlaceholder="YYYY"
                  minDate={new Date()}
                />
                <ErrorText error={errors.travelDate?.message} />
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="form-group with-icon">
                <CustomStaticSelect
                  label="Class"
                  name="class"
                  id="class"
                  register={register}
                  registerOpt={{
                    required: true,
                  }}
                  optionArr={classArr}
                />
                <ErrorText error={errors.class?.message} />
              </div>
            </div>
          </div>
          <button
            type="button"
            onClick={() => {
              handleSubmit(onSubmit)();
            }}
            className="btn btn-primary btn-lg btn-rounded search-button"
          >
            Save Enquiry
          </button>
        </form>
        {showFormSubmissionPopup && (
          <SendQueryFormComponent
            subject="Train Enquiry"
            onHide={() => {
              setShowFormSubmissionPopup(false);
            }}
            buttonLabel="Send Train Enquiry"
            formDetails={formData}
            popupTitle={"Send Train Enquiry"}
            setFormDetails={() => {
              setValue("travelDate", undefined);
              setValue("fromCityDetails", "");
              setValue("toCityDetails", "");
              setValue("class", "Sleeper");
            }}
          />
        )}
      </div>
    </div>
  );
};
export default TrainQueryForm;
